import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoginModel, LoginCredentialModel } from '../../models/login.model';
import { CommonMethodService } from '../../common/commonMethod.service';
import { MessagingService } from '../../services/messaging.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  providers: [LoginService, CommonMethodService]
})
export class LoginComponent implements OnInit, OnDestroy {

  subscribe: Array<Subscription> = [];
  constructor(private toaster: ToastrService, private route: Router, private loginService: LoginService,
    private commonMethod: CommonMethodService, private messagingService: MessagingService) { }

  loginForm: FormGroup;
  fcmToken: string;
  loader: boolean = false;

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }
    this.fcmToken = sessionStorage.getItem('fcmToken') || '';
    this.loader = true;
    this.messagingService.requestPermission().catch(() => { this.fcmToken = ''; });
    const deatils: LoginCredentialModel = this.loginForm.value;
    deatils.fcmToken = this.fcmToken;
    this.subscribe.push(this.loginService.login(deatils).subscribe(
      data => {
        this.loader = false;
        const wrapper: LoginModel = JSON.parse(JSON.stringify(data));
        sessionStorage.clear();
        if (wrapper.role === 'DEVICE_ADMIN') {
          if (wrapper.mobileMode === null || wrapper.mobileMode === undefined || wrapper.mobileMode === 'mobile') {
            this.toaster.error('You do not have permission to login.');
            return false;
          }
          sessionStorage.setItem('flatId', wrapper.flatId.toString());
        }
        const store = (key: string, value: any) => {
          if (value !== null && value !== undefined && value !== 'undefined' && value !== 'null') {
            sessionStorage.setItem(key, value.toString());
          }
        };
        store('token', wrapper.id_token);
        store('accountName', wrapper.accountName);
        store('username', this.loginForm.value.username);
        store('type', wrapper.type);
        store('role', wrapper.role);
        store('dialingCode', wrapper.dialingCode);
        store('county', wrapper.county);
        store('country', wrapper.country);
        store('bindingEligible', wrapper.bindingEligible ? 'true' : 'false');
        store('licenseStatus', wrapper.licenseStatus ? wrapper.licenseStatus : 'VALID');

        if (wrapper.role === 'RESIDENT_ADMIN' || wrapper.role === 'FAMILY') {
          sessionStorage.setItem('residentId', wrapper.residentId.toString());
          sessionStorage.setItem('flatId', wrapper.flatId.toString());
          sessionStorage.setItem('hostCheckOut', wrapper.hostCheckOut.toString());
        }
        const accountIdNum = Number(wrapper.accountId);
        if (accountIdNum > 0) {
          sessionStorage.setItem('accountId', accountIdNum.toString());
          if (wrapper.userMasterId !== null && wrapper.userMasterId !== undefined) {
            sessionStorage.setItem('userMasterId', wrapper.userMasterId.toString());
          }
          sessionStorage.setItem('userImage', wrapper.image ? wrapper.image : '');
        }
        if (wrapper.role === 'EMPLOYEE_ADMIN') {
          sessionStorage.setItem('employeeId', wrapper.employeeId.toString());
          sessionStorage.setItem('hostCheckOut', wrapper.hostCheckOut.toString());
        }
        if (wrapper.role === 'ACCOUNT_ADMIN') {
          sessionStorage.setItem('flatId', wrapper.flatId.toString());
        }
        this.route.navigate(['/home/dashboard']);
        this.toaster.success('You have successfully logged in');
      }, error => {
        this.loader = false;
        this.commonMethod.returnErrorMessage(error);
        sessionStorage.clear();
      }));
  }

  forgetPassword(): void {
    this.route.navigate(['/forget-password']);
  }

  signUp(): void {
    this.route.navigate(['/sign-up']);
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }
}
